import type { PropsWithChildren } from 'react';
import React, { useContext, createContext } from 'react';

const context = createContext<string>('');

export function SizeContextProvider({ children, value }: PropsWithChildren<{ value: string }>) {
  return <context.Provider value={value}>{children}</context.Provider>;
}

export const useSizeContext = () => useContext(context);
